module.exports = __webpack_public_path__ + "img/hongqiaozhongyang.bbc1e4c2.jpg";